import { jsx as _jsx } from "react/jsx-runtime";
export function CircleStack({ items, renderItem, size = 26, overlap, gap = 2, max = 4, direction = 'left-on-top', }) {
    const slide = overlap ?? Math.round(size * 0.3);
    const visible = items.slice(0, max);
    const biteR = size / 2 + gap;
    const r = size / 2;
    // Bite center in the carved disc's coords: right→`(size-slide+r, r)`, left→`(slide-r, r)`.
    const biteCxRight = size - slide + r;
    const biteCxLeft = slide - r;
    return (_jsx("div", { style: { display: 'inline-flex' }, children: visible.map((item, i) => {
            const isFirst = i === 0;
            const isLast = i === visible.length - 1;
            const carveCx = direction === 'left-on-top'
                ? !isFirst
                    ? biteCxLeft
                    : null
                : !isLast
                    ? biteCxRight
                    : null;
            const carve = carveCx !== null
                ? `radial-gradient(circle at ${carveCx}px ${r}px, transparent ${biteR}px, black ${biteR + 0.5}px)`
                : undefined;
            const zIndex = direction === 'left-on-top' ? visible.length - i : i;
            return (_jsx("span", { style: {
                    position: 'relative',
                    zIndex,
                    width: size,
                    height: size,
                    marginLeft: i === 0 ? 0 : -slide,
                    borderRadius: 'var(--radius-full)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    flexShrink: 0,
                    boxSizing: 'border-box',
                    ...(carve
                        ? { maskImage: carve, WebkitMaskImage: carve }
                        : {}),
                }, children: renderItem(item, i) }, i));
        }) }));
}
//# sourceMappingURL=CircleStack.js.map